import { render, staticRenderFns } from "./CatalogFiltersComponent.vue?vue&type=template&id=3deee54b"
import script from "./CatalogFiltersComponent.vue?vue&type=script&lang=js"
export * from "./CatalogFiltersComponent.vue?vue&type=script&lang=js"
import style0 from "./CatalogFiltersComponent.vue?vue&type=style&index=0&id=3deee54b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports